/* eslint-disable no-bitwise, no-magic-numbers */
import type { Color as PluginColor } from 'minerva-plugin-api';
import { Color } from '@/types/models';

const HEX_RADIX = 16;

/**
 * The API used to serialize colors as `{ alpha, rgb }`, where `rgb` was a signed
 * 32-bit ARGB integer. It now sends `#RRGGBBAA` strings, but plugins are still
 * given the old representation so that they keep working.
 */
export const toPluginColor = (color: Color): PluginColor => {
  const sanitizedColor = color.replace(/^#/, '');
  const red = parseInt(sanitizedColor.slice(0, 2), HEX_RADIX);
  const green = parseInt(sanitizedColor.slice(2, 4), HEX_RADIX);
  const blue = parseInt(sanitizedColor.slice(4, 6), HEX_RADIX);
  const alpha = parseInt(sanitizedColor.slice(6, 8), HEX_RADIX);

  return {
    alpha,
    rgb: (alpha << 24) | (red << 16) | (green << 8) | blue | 0,
  };
};

/**
 * Some elements handed to plugins are built by hand and have no colors at all
 * (see mapReactionToModelElement), so a missing color stays missing.
 */
export const toOptionalPluginColor = (color: Color | undefined): PluginColor | undefined =>
  color === undefined ? undefined : toPluginColor(color);
